import React, { useState, useEffect } from 'react';
import { LoaderComponent, MediaOpsService, NoDataComponent, OmniIconComponent, Utils } from '../../../../../shared';
import CampaignOverviewSection from './CampaignOverviewSection';
import MediaOrdersTable from './MediaOrdersTable';
import CreateMediaOrderWizard from './CreateMediaOrderWizard';

const CampaignDetailComponentV3 = (params) => {
    const [campaignData, setCampaignData] = useState(null);
    const [isWizardOpen, setIsWizardOpen] = useState(false);
    const [filterOptions, setFilterOptions] = useState({
        searchText: '',
        selectedFilters: []
    });
    const [clientCodes, setClientCodes] = useState([]);
    const [campaignDataWithChildren, setCampaignDataWithChildren] = useState(null);
    //const [spinnerCount, setSpinnerCount] = useState(0);

    /**
     * Renders skeleton loader for campaign overview cards
     */
    const renderOverviewSkeleton = () => {
        return (
            <div className="campaign-overview-section">
                <div className="campaign-overview-cards">
                    {[1, 2, 3, 4].map((item) => (
                        <div key={item} className="skeleton-card">
                            <div className="skeleton-header">
                                <div className="skeleton-line skeleton-title"></div>
                            </div>
                            <div className="skeleton-card-body">
                                <div className="skeleton-chart-placeholder">
                                    <div className="skeleton-bar"></div>
                                    <div className="skeleton-bar"></div>
                                    <div className="skeleton-bar"></div>
                                    <div className="skeleton-bar"></div>
                                    <div className="skeleton-bar"></div>
                                </div>
                                <div className="skeleton-data-section">
                                    <div className="skeleton-line skeleton-data-item"></div>
                                    <div className="skeleton-line skeleton-data-item"></div>
                                    <div className="skeleton-line skeleton-data-item"></div>
                                    <div className="skeleton-line skeleton-data-item"></div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    /**
     * Renders skeleton loader for media orders table
     */
    const renderTableSkeleton = () => {
        return (
            <div className="media-orders-table-skeleton">
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((row) => (
                    <div key={row} className="skeleton-table-row">
                        <div className="skeleton-cell skeleton-cell-small"></div>
                        <div className="skeleton-cell skeleton-cell-large"></div>
                        <div className="skeleton-cell skeleton-cell-medium"></div>
                        <div className="skeleton-cell skeleton-cell-small"></div>
                        <div className="skeleton-cell skeleton-cell-medium"></div>
                        <div className="skeleton-cell skeleton-cell-medium"></div>
                        <div className="skeleton-cell skeleton-cell-medium"></div>
                        <div className="skeleton-cell skeleton-cell-small"></div>
                    </div>
                ))}
            </div>
        );
    };

    useEffect(() => {
        params.setSpinnerCount(0);
        if (params.state?.campaignObj) {
            fetchCampaignDetails();
            fetchClientCodes();
        }
    }, []);

    const fetchCampaignDetails = async () => {
        //incrementSpinner();
        let campaignId = params.state?.campaignObj?.id ? encodeURIComponent(params.state?.campaignObj?.id) : params?.params?.campaignId;
        MediaOpsService.getCampaignDataById(campaignId, params.state?.campaignObj?.client_id, params?.versionOneApi).then((campaignData) => {
            setCampaignData(campaignData);
            params.setCampaignName(Utils.formatCampaignTitle(campaignData[0]));
            if(campaignData[0]){
                fetchChildCampaigns(campaignData[0]); // todo update after backend changes in single campaign api call    
            }
        }).catch((error) => {
            console.error('Error fetching campaign details:', error);
        }).finally(() => {
            //decrementSpinner();
            //params.setSpinnerCount(0);
        });
    };

    const fetchClientCodes = () => {
        MediaOpsService.getClientCodes().then(
          (response) => {
            let clientCodes = [...response?.data?.client_codes]
            setClientCodes(clientCodes);
          }
        ).finally(() => {
        });
      };

    const fetchChildCampaigns = async (parentCampaign) => {
        //incrementSpinner();
        const payload = {
            'source': 'children',
            'parent-id': parentCampaign?.id,
            'campaign-id': parentCampaign?.synthetic_id,
            'client-id': Utils.getRouteParam("clientid")
        };

        MediaOpsService.getCampaignData(payload, null, false).then((childCampaignsData) => {
            const childCampaigns = childCampaignsData?.data?.Items || [];
            let combined = [parentCampaign, ...childCampaigns];
            combined = MediaOpsService.prepareCampaignData(combined);
            setCampaignDataWithChildren(combined);
            //decrementSpinner();
        }).catch((error) => {
            console.error('Error fetching child campaigns:', error);
            //decrementSpinner();
        });

    }

    // /**
    //  * Increments the spinner count for loading state management
    //  */
    // const incrementSpinner = () => {
    //     setSpinnerCount(prevCount => prevCount + 1);
    // };

    // /**
    //  * Decrements the spinner count, ensuring it doesn't go below 0
    //  */
    // const decrementSpinner = () => {
    //     setSpinnerCount(prevCount => Math.max(0, prevCount - 1));
    // };

    const handleOpenWizard = () => {
        setIsWizardOpen(true);
    };

    const handleCloseWizard = () => {
        setIsWizardOpen(false);
    };

    const handleWizardSubmit = async (formData) => {
        try {
            // TODO: Implement API call to create media order
            console.log('Media Order Data:', formData);
            setIsWizardOpen(false);
            // Refresh media orders table
        } catch (error) {
            console.error('Error creating media order:', error);
        }
    };

    const handleFilterChange = (filters) => {
        setFilterOptions(filters);
    };


    return (<>
        <div className="campaign-detail-v3">

            {/* {params.spinnerCount == 0 && <LoaderComponent spinnerCount={spinnerCount} displayWholePage={true} />} */}

            {/* Campaign Overview Section - Top cards and Plan Alignment */}
            {campaignData === null ? (
                renderOverviewSkeleton()
            ) : campaignData?.length === 0 ? (
                <NoDataComponent
                    heading={"No Data Found"}
                    message={"No campaign data available"}
                />
            ) : (
                <CampaignOverviewSection 
                    campaignData={campaignData[0]}
                />
            )}

            {/* Media Orders Section */}
            {campaignData === null || campaignDataWithChildren === null ? (
                <div className="media-orders-section">
                    <div className="media-orders-header">
                        <h2>Media Orders</h2>
                    </div>
                    <div key="mediaOrderTableWrapper" className="media-orders-table-wrapper">
                        {renderTableSkeleton()}
                    </div>
                </div>
            ) : campaignData?.length > 0 && campaignDataWithChildren !== null && (
                <div className="media-orders-section">
                    <div className="media-orders-header">
                        <h2>Media Orders</h2>
                        <div className="media-orders-actions">
                            <OmniIconComponent className="is-size-2" icon-id="omni:interactive:funnel" onClick={() => {/* TODO: Implement filter toggle */ }} />
                            <OmniIconComponent className="is-size-2" icon-id="omni:interactive:add" onClick={handleOpenWizard} />
                        </div>
                    </div>

                    <div key="mediaOrderTableWrapper" className="media-orders-table-wrapper">
                        <MediaOrdersTable
                            campaignObj={campaignData[0]}
                            filters={filterOptions}
                            campaignTaxonomyData={params.campaignTaxonomyData}
                            systemParametersData={params.systemParametersData}
                            navigate={params.navigate}
                            campaignDataWithChildren={campaignDataWithChildren}
                        />
                    </div>
                </div>
            )}

            {/* Media Order Creation Wizard */}
            {isWizardOpen && (
                <CreateMediaOrderWizard
                    isOpen={isWizardOpen}
                    campaignTaxonomyData={params.campaignTaxonomyData}
                    onClose={handleCloseWizard}
                    onSubmit={handleWizardSubmit}
                    campaignData={campaignData}
                    clientCodes={clientCodes}
                    systemParametersData={params.systemParametersData}
                />
            )}
        </div>
        </>
    );
};

export default CampaignDetailComponentV3;
